import { type FC } from "react";

interface PaginationProps {
  currentPage: number;
  totalItems: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange?: (size: number) => void;
  pageSizeOptions?: number[];
}

export const Pagination: FC<PaginationProps> = ({
  currentPage,
  totalItems,
  pageSize,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 25, 50],
}) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const isFirstPage = currentPage <= 1;
  const isLastPage = currentPage >= totalPages;

  return (
    <div className="vmx-pagination">
      <div className="vmx-pagination-info">
        Page {currentPage} of {totalPages}
        <span className="vmx-pagination-total">
          ({totalItems} {totalItems === 1 ? "item" : "items"})
        </span>
      </div>
      <div className="vmx-pagination-controls">
        {onPageSizeChange && (
          <select
            className="vmx-select vmx-pagination-size"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
          >
            {pageSizeOptions.map((size) => (
              <option key={size} value={size}>
                {size} / page
              </option>
            ))}
          </select>
        )}
        <button
          className="vmx-btn vmx-btn-secondary vmx-btn-sm vmx-pagination-prev"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={isFirstPage}
        >
          ← Previous
        </button>
        <button
          className="vmx-btn vmx-btn-secondary vmx-btn-sm vmx-pagination-next"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={isLastPage}
        >
          Next →
        </button>
      </div>
    </div>
  );
};
